import { render, staticRenderFns } from "./MerchantListSetting.vue?vue&type=template&id=5a34fe4a&scoped=true&"
import script from "./MerchantListSetting.vue?vue&type=script&lang=js&"
export * from "./MerchantListSetting.vue?vue&type=script&lang=js&"
import style0 from "./MerchantListSetting.vue?vue&type=style&index=0&id=5a34fe4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a34fe4a",
  null
  
)

export default component.exports